import { Button, IconButton } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import CloseIcon from 'assets/icons/ico/close.svg';
import LegalNoticeContent from 'components/Options/LegalNotice/LegalNoticeContent';
import { useTranslation } from 'react-i18next';
import React from 'react';
import './termsView.scss';
import StyledIcon from 'components/CommonKit/Icon/StyledIcon';

interface LegalNoticeModalProps {
  open: boolean;
  handleCloseClick: () => void;
}

const LegalNoticeModal = ({
  open,
  handleCloseClick,
}: LegalNoticeModalProps) => {
  const { t } = useTranslation();
  return (
    <Dialog
      open={open}
      onClose={handleCloseClick}
      aria-labelledby="accessibility-title"
      classes={{
        root: 'modal-root',
        paper: 'modal-paper',
      }}
    >
      <div id="accessibility-title">{t('legal.title_legal')}</div>
      <IconButton
        aria-label={t('feedback.accessibility.button_close')}
        className="modal-paper-close-button"
        onClick={handleCloseClick}
      >
        <StyledIcon icon={CloseIcon} width={16} />
      </IconButton>
      <LegalNoticeContent />
      <Button
        aria-label={t('gcu_modal.accessibility.button_accept')}
        onClick={handleCloseClick}
        className="gcu-modal-button btn-profile-next rounded text-16-bold"
      >
        <span>{t('legal.accessibility.button_close')}</span>
      </Button>
    </Dialog>
  );
};

export default LegalNoticeModal;
